import { stegaClean } from "@sanity/client/stega";

// Use only before non-source-preserving transforms: split, serialize, strip,
// concatenate, or hand text to DOM-mutating animation libraries.
export function cleanStegaForTextTransform(value: string): string {
  return stegaClean(value);
}
export function composeStegaCleanLabel(parts: Array<string | null | undefined>, separator = " ") {
  return parts.filter((part): part is string => Boolean(part)).map(part => cleanStegaForTextTransform(part)).join(separator);
}